import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/profile")({
  head: () =>
    buildHead({
      title: "My Profile | LohaLink",
      description: "Manage your LohaLink business profile, KYC and bank verification.",
      canonical: "/profile",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/Profile")),
});
